import { useCallback, useState } from 'react';

import { Button } from '@bambi/component-library/src/components/Button';

import { useAppDispatch } from 'src/app/store/hooks';
import { Modal, ModalProps } from 'src/common/primitives/Modal';
import { ModalTitle } from 'src/common/primitives/Modal/ModalTitle';

import { AttendantProfileForm } from '../attendant/AttendantProfileForm/AttendantProfileForm';
import {
  NextStepOption,
  ProfileListSelect,
} from '../components/ProfileListSelect';
import { DriverProfileForm } from '../DriverProfileForm/DriverProfileForm';
import {
  setShowAttendantProfileModal,
  setShowDriverProfileModal,
} from '../team.slice';

export function ProfileTypeSelectModal({
  open,
  setOpen,
  onClose,
}: Omit<ModalProps, 'children'>) {
  const dispatch = useAppDispatch();
  const [value, setValue] = useState<NextStepOption>('driver-attendant');
  const handleClick = useCallback(() => {
    if (value === 'driver-attendant') {
      dispatch(setShowDriverProfileModal(true));
    } else {
      dispatch(setShowAttendantProfileModal(true));
    }
  }, [dispatch, value]);

  const handleCancel = useCallback(() => {
    setValue('driver-attendant');
    setOpen(false);
  }, [setOpen, setValue]);

  return (
    <>
      <Modal
        open={open}
        setOpen={setOpen}
        onClose={onClose}
        title="Add driver or attendant profile for new member"
      >
        <div className="flex flex-col gap-2">
          <ModalTitle>Select member profile</ModalTitle>
          <ProfileListSelect onChange={setValue} value={value} />
          <div className="flex flex-row gap-1">
            <Button
              variant="secondary"
              className="w-full"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button variant="primary" className="w-full" onClick={handleClick}>
              Next
            </Button>
          </div>
        </div>
      </Modal>
      <DriverProfileForm />
      <AttendantProfileForm />
    </>
  );
}
